const presetsTemplates = require('./presets-templates');
// const projectRecords = require('./projectRecords');
const notFound = require('./notFound');
const authorization = require('./authorization');
const reports = require('./reports');
const chartPage = require('./chartPage');
const usersPage = require('./users');
const settings = require('./settings');
const chatMetricTemplates = require('./chat_metric_template')
const chatAnalytics = require('./chat_analytics')
// const dashboard = require('./dashboard');
// const records = require('./records');
const compositeMetric = require('./composite-metric');
const metricTemplates = require('./analytics-project-metric-and-templates');
const dictionaries = require('./dictionaries');
const analytics = require('./analytics');
const wordsCloud = require('./wordsCloud');
const analyticsProjectPreset = require('./analytics-project-preset');
const analyticsProjectRecords = require('./analytics-project-records');
const analyticsProjectMainSettings= require('./analytics-project-main-settings');
const wordsNGramm = require('./wordsNGramm');
const auditLogs = require('./auditLogs');
const dashboardPage = require('./dashboard')
const allRecords = require('./all-records')
const allChats = require('./all-chat')
const recordsByAnalytics = require('./records-by-analytics-projects')
const triggers = require('./triggers')
const qmManage = require('./qmManage')
const qmAppeal = require('./qm-appellations')
const qmScoreTemplates = require('./qm_score_templates')

module.exports = {
  dashboard:dashboardPage,
  allChats,
  notFound,
  allRecords,
  settings,
  chartPage,
  reports,
  chatMetricTemplates: chatMetricTemplates,
  chatAnalytics,
  auditLogs,
  dictionaries,
  wordsNGramm,
  usersPage,
  wordsCloud,
  analytics,
  authorization,
  presetAp:analyticsProjectPreset,
  recordsAp:analyticsProjectRecords,
  mainSettingsAp:analyticsProjectMainSettings,
  metric:compositeMetric,
  metricTemplates,
  recordsByAnalytics,
  presets:presetsTemplates,
  triggers,
  qmManage,
  qmAppeal,
  qmScoreTemplates
  // projectRecords,
  // dashboard,
  // records,
};
